import { Button, Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HamburgerIcon from "../../../components/icons/HamburgerIcon";
import Logo from "../../../components/icons/Logo";
import { dashboardAction } from "../../../redux/features/dashboardSlice";
import "./Header.scss";
import { AuthHelpers } from "../../../utils/auth.helpers";
import AgentMenuDetails from "./AgentMenuDetails";
import AgencyMenuDetails from "./AgencyMenuDetails";
import { LocalStorageHelpers } from "../../../utils/helpers/localstorage.helpers";
import { IProfileAgency, IProfileAgent } from "../../../@types/api-data.types";
import { getImageUrl, getProfileImageUrl } from "../../../utils/helpers/common";
import { AgentApi } from "../../../utils/api/Agent";
import { AgencyApi } from "../../../utils/api/Agency";
import { RootState } from "../../../redux/store";
import { useNavigate } from "react-router-dom";
import { CommonEnums } from "../../../enums/common.enums";
import { clientRoutes } from "../../../utils/routes";
import MainLogo from "../../../components/icons/MainLogo";
import NotificationIcon from "../../../components/icons/NotificationIcon";
import MainMobileIcon from "../../../components/icons/MainMobileIcon";
import HeaderNotificationIcon from "../../../components/icons/HeaderNotificationIcon";

const menuTypes = {
  logout: "logout",
};

interface ThemeColor {
  r: number;
  g: number;
  b: number;
  pixel_counts: number;
}

interface stateType {
  isLoading: boolean;
  profileMenu: boolean;
  agentData: IProfileAgent | null;
  agencyData: IProfileAgency | null;
  type: string;
  base_color: string;
  text_color: string;
  agency_logo: string;
  profile_image: string;
  theme_colors: ThemeColor[];
}

const Header = () => {
  let profileData = useSelector(
    (state: RootState) => state?.dashboard?.profileData
  );
  const [state, setState] = useState<stateType>({
    isLoading: false,
    profileMenu: false,
    agentData: null,
    agencyData: null,
    type: "",
    base_color: "",
    text_color: "",
    agency_logo: "",
    profile_image: "",
    theme_colors: [],
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setState({
      ...state,
      profileMenu: true,
    });
  };

  const onClickHamburger = () => {
    dispatch(dashboardAction?.setsideBar());
  };

  const getData = async () => {
    let data: any =
      LocalStorageHelpers?.getAgentData() ||
      LocalStorageHelpers?.getAgencyData();

    if (data?.role === "agent") {
      setState({
        ...state,
        agentData: data,
        type: "agent",
        base_color: data?.agency_ref?.agency_base_color,
        agency_logo: data?.agency_ref?.profile_image_ref?.original_file_path,
        profile_image: data?.profile_image_ref?.compressed_file_path,
        text_color: data?.agency_ref?.design_text_color?.hex,
        theme_colors: data?.agency_ref?.theme_colors || [],
      });
      let res = await AgentApi.GetAgentProfile();
      if (res?.data?.success) {
        let newAgentData = res?.data?.data;
        setState({
          ...state,
          agentData: newAgentData,
          type: "agent",
          base_color: newAgentData?.agency_ref?.agency_base_color,
          agency_logo:
            newAgentData?.agency_ref?.profile_image_ref?.original_file_path,
          profile_image: newAgentData?.profile_image_ref?.compressed_file_path,
          text_color: newAgentData?.agency_ref?.design_text_color?.hex,
          theme_colors: newAgentData?.agency_ref?.theme_colors || [],
        });
      }
    } else {
      setState({
        ...state,
        agencyData: data,
        type: "agency",
        base_color: data?.agency_base_color,
        agency_logo: data?.profile_image_ref?.original_file_path,
        profile_image:
          data?.principal_agent_id?.profile_image_ref?.compressed_file_path,
        text_color: data?.design_text_color?.hex,
        theme_colors: data?.theme_colors || [],
      });

      let res = await AgencyApi.getAgencyDetails();

      if (res?.data?.success) {
        let newAgencyData = res?.data?.data;
        setState({
          ...state,
          agencyData: newAgencyData,
          type: "agency",
          base_color: newAgencyData?.agency_ref?.agency_base_color,
          agency_logo: newAgencyData?.profile_image_ref?.original_file_path,
          profile_image:
            newAgencyData?.principal_agent_id?.profile_image_ref
              ?.compressed_file_path,
          text_color: newAgencyData?.design_text_color?.hex,
          theme_colors: newAgencyData?.theme_colors || [],
        });
      }
    }
  };

  const handleLogout = () => {
    AuthHelpers.logOut();
  };

  const handleClose = () => {
    setState({
      ...state,
      profileMenu: false,
    });
  };

  const handleCloseMenuItem = (link: string) => {
    navigate(link);
    handleClose();
  };

  useEffect(() => {
    getData();

    const userProfileImages = document.querySelectorAll(".user-profile-image");

    userProfileImages.forEach((profileImage) => {
      profileImage.addEventListener("error", (event: any) => {
        event.src = "images/profile-placeholder-image.png";
      });
    });
  }, [profileData]);

  const menuItem = [
    // {
    //   id: "1",
    //   type: "",
    //   menuName: "Switch to Agent Profile",
    // },
    {
      id: "2",
      type: "",
      menuName: "View Profile",
      link:
        state?.type === CommonEnums?.userRole?.agent
          ? clientRoutes?.agentProfileView
          : clientRoutes?.agencyProfileView,
    },
    {
      id: "1",
      type: "",
      menuName: "Agent Subscription",
      link: "",
    },
    {
      id: "3",
      type: "",
      menuName: "Invitations",
      link: "/manage-invites",
    },
    {
      id: "4",
      type: "",
      menuName: "Account",
      link: "",
    },
    // ...(state?.type === CommonEnums?.userRole?.agency
    //   ? [
    //       {
    //         id: "5",
    //         type: "",
    //         menuName: "Settings",
    //         link: `${clientRoutes?.accountSettings}?type=${CommonEnums?.accountSettingsTabs?.configure_property_stages?.key}`,
    //       },
    //     ]
    //   : []),
    {
      id: "5",
      type: "",
      menuName: "Settings",
      link: `${clientRoutes?.accountSettings}?type=${CommonEnums?.accountSettingsTabs?.configure_property_stages?.key}`,
    },
    {
      id: "6",
      type: "",
      menuName: "Support & Help!",
      link: "",
    },
    {
      id: "7",
      type: menuTypes.logout,
      menuName: "Logout",
      link: "",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".top-header");
      if (window.scrollY > 50) {
        header?.classList.add("scrolled");
      } else {
        header?.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const rgbToCss = (color?: ThemeColor) => {
    if (!color) return "transparent";
    return `rgb(${color.r}, ${color.g}, ${color.b})`;
  };

  return (
    <div className="header-main-container">
      <div
        className="top-header"
        style={{ backgroundColor: rgbToCss(state.theme_colors[0]) }}
      >
        <div className={`header-left-contain`}>
          <div className="hamburger-icon" onClick={onClickHamburger}>
            <HamburgerIcon />
          </div>
          <div className="logo">
            <div className="web-icon">
              <MainLogo />
            </div>
            <div className="mobile-icon">
              <MainMobileIcon />
            </div>
          </div>
        </div>

        <div className="header-divider"></div>

        <div
          className="main-header-agency-image"
          style={{ backgroundColor: rgbToCss(state.theme_colors[0]) }}
        >
          <img src={getImageUrl(state?.agency_logo || "")} alt="" />
        </div>

        <div className="profile-image-and-notification-icon">
          <div className="web-notification-icon">
            <HeaderNotificationIcon stroke={state?.text_color} />
          </div>
          <div className="mobile-notification-icon">
            <NotificationIcon />
          </div>
          <Button
            id="basic-button"
            onClick={handleClick}
            className="profile-logo"
          >
            <img
              className="user-profile-image"
              src={getProfileImageUrl(state?.profile_image || "")}
              alt="User"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = "/images/profile-placeholder-image.png";
              }}
            />
          </Button>
        </div>
      </div>

      <div
        className={`profile-menu-container ${
          state?.profileMenu ? "" : "display-none"
        }`}
      >
        <div className="profile-menu-bg" onClick={handleClose}></div>

        <div className="profile-menu-box">
          {state?.type === "agent" ? (
            <AgentMenuDetails
              handleClose={handleClose}
              agentData={state?.agentData}
            />
          ) : (
            <AgencyMenuDetails
              handleClose={handleClose}
              agencyData={state?.agencyData}
            />
          )}
          <div className="menu-navigation-contain-container">
            {menuItem?.map((item) => {
              if (item.type === menuTypes.logout) {
                return (
                  <MenuItem onClick={handleLogout} key={item?.id}>
                    {item?.menuName}
                  </MenuItem>
                );
              }

              return (
                <MenuItem
                  onClick={() => handleCloseMenuItem(item?.link)}
                  key={item?.id}
                >
                  {item?.menuName}
                </MenuItem>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
